import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { BASE_URLS } from '../../../config/appConfig';
import { RegionTypes } from '../../../config/regions';
import { RegionService } from '../../../services/regionService';

export const LegacyRegionHandler = ({ region }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const params = useParams();

	useEffect(() => {
		const rest = params['*'] || '';
		const target = `/${rest}${location.search}${location.hash}`;

		if (region === new RegionService().currentRegion()) {
			navigate(target, { replace: true });
			return;
		}

		const origin =
			region === RegionTypes.SaudiArabia ? BASE_URLS.sa : BASE_URLS.en;
		window.location.replace(`${origin.replace(/\/+$/, '')}${target}`);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return null;
};

export default LegacyRegionHandler;
